module.exports = __webpack_public_path__ + "static/media/values-icon.537a9d3e.png";